import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent as CommonAlertComponent } from '@libs/common/components';
import { AlertItemModel } from '@libs/form/models';
import { ItemBaseComponent } from '../../../models';

@Component({
  selector: 'ui-form-alert',
  template: '<ui-alert [message]="data.content" [theme]="data.variant"></ui-alert>',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonAlertComponent,
  ],
})
export class AlertComponent extends ItemBaseComponent {
  @Input() public data!: AlertItemModel;
}
